import React from 'react';
import { motion } from 'framer-motion';
import { FileTextIcon, ZapIcon } from 'lucide-react';
import { ActionButton } from './ActionButton';
const mockupUrl = 'https://cdn.magicpatterns.com/uploads/bsrhuTJ8Qf7Ke4PjH7yFc5/Mockup_-_SN25_(1x1).webp';
export function Hero() {
  return <section className="relative overflow-hidden bg-brand-dark px-4 pb-16 pt-12 sm:pb-24 sm:pt-16" data-id="element-65" data-mp="4lqfmm6wsuyr">
      <div className="pointer-events-none absolute inset-x-0 top-0 h-px bg-brand-green/40" data-id="element-66" data-mp="1297c23jh2z9b" />
      <div className="relative mx-auto max-w-5xl text-center" data-id="element-67" data-mp="xae7x1q2sklt">
        <motion.p initial={{
        opacity: 0,
        y: 10
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.3,
        ease: [0.23, 1, 0.32, 1]
      }} className="-mb-2 -mt-8 font-display text-lg font-bold tracking-[.18em] text-brand-light sm:text-2xl" data-id="element-68" data-mp="xb5tdjpyl1yd">
          🌿 BIOMA LÍVIDO™
        </motion.p>
        <motion.h1 initial={{
        opacity: 0,
        y: 18
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        delay: 0.08,
        duration: 0.3,
        ease: [0.23, 1, 0.32, 1]
      }} className="mx-auto mt-5 max-w-5xl font-display text-[19px] font-bold text-white sm:text-5xl lg:text-6xl" style={{
        fontSize: "18px"
      }} data-id="element-69" data-mp="381xn73sg3cct">
          Organizá tus comidas para acompañar el control de tu glucosa en 30 días,{' '}
          <span className="text-brand-light" data-id="element-70" data-mp="3ebioshvyf20f">
            sin dietas rígidas ni miedo constante a comer.
          </span>
        </motion.h1>
        <motion.div initial={{
        opacity: 0,
        y: 26
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        delay: 0.14,
        duration: 0.3,
        ease: [0.23, 1, 0.32, 1]
      }} className="mx-auto -my-3 max-w-xs sm:-my-7 sm:max-w-lg" data-id="element-71" data-mp="358zqmb345dki">
          <img src={mockupUrl} alt="Mockup del Protocolo Glucosa Bajo Control" width="1240" height="1240" fetchPriority="high" loading="eager" decoding="async" className="w-full drop-shadow-2xl" data-id="element-72" data-mp="2hjf8tvip4mct" />
        </motion.div>
        <motion.div initial={{
        opacity: 0,
        y: 12
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        delay: 0.2,
        duration: 0.3,
        ease: [0.23, 1, 0.32, 1]
      }} className="mx-auto max-w-2xl" data-id="element-73" data-mp="s2b7hx6yyh4m">
          <p className="-mb-2 font-display text-base font-bold tracking-[.14em] text-brand-gold sm:text-xl" data-id="element-74" data-mp="i9vqp37erylb">
            PROTOCOLO GLUCOSA BAJO CONTROL™
          </p>
          <p className="-mb-4 mt-3 text-slate-200 sm:text-base text-[13px]" data-id="element-75" data-mp="1b0drfxkntnvk">
            Un sistema de 5 volúmenes para mujeres argentinas +55 con diabetes o prediabetes que quieren comer con más claridad, tranquilidad y sin prohibirse todo.
          </p>
          <div className="-mb-5 mt-5 flex flex-wrap justify-center gap-2 text-xs font-medium text-slate-300 sm:text-sm" data-id="element-76" data-mp="x1ecjhmy8ncl">
            <span className="inline-flex items-center gap-2 rounded-full border border-white/15 bg-brand-ink px-3 py-2" data-id="element-77" data-mp="3lu04j5ufbd1u">
              <FileTextIcon className="h-4 w-4 text-brand-light" data-id="element-78" data-mp="3hpsf16g55t2k" />
              100% PDF
            </span>
            <span className="inline-flex items-center gap-2 rounded-full border border-white/15 bg-brand-ink px-3 py-2" data-id="element-79" data-mp="1xb5qkgbtuvh6">
              <ZapIcon className="h-4 w-4 text-brand-gold" data-id="element-80" data-mp="218jubsgqob1s" />
              Acceso en 5 min
            </span>
          </div>
        </motion.div>
        <motion.div initial={{
        opacity: 0,
        scale: 0.97
      }} animate={{
        opacity: 1,
        scale: 1
      }} transition={{
        delay: 0.26,
        duration: 0.3,
        ease: [0.23, 1, 0.32, 1]
      }} className="mx-auto mt-7 max-w-lg" data-id="element-81" data-mp="2b1rb09gxjdh6">
          <ActionButton href="#pricing" showTrust data-id="element-82" data-mp="2p0qoqm2wm7yk">
            🩺 QUIERO MI PROTOCOLO AHORA
          </ActionButton>
        </motion.div>
      </div>
    </section>;
}